import formatDate from "./date.js"

const dateRange = (start, end, treatUndefinedAsPresent = false) => {
  // For Work Experience: undefined means "Present" (the current job)
  // For Education: undefined means no date provided (show nothing)
  const endDateToUse = (end === undefined && treatUndefinedAsPresent) ? null : end

  const startDate = formatDate(start)
  const endDate = formatDate(endDateToUse, true)

  if (!startDate && !endDate) {
    return ''
  }

  if (!startDate) {
    return endDate
  }

  return `${startDate} - ${endDate}`
}

export default dateRange
